// eslint-disable-next-line import/no-unresolved
import KeenSlider from 'https://cdn.skypack.dev/pin/keen-slider@v6.6.14-XM80lRoYRUdkHMpUfMaX/mode=imports,min/optimized/keen-slider.js'

const { config, spacing } = window.BAO.Carousel
const { setInitialised, addWheelControls } = window.BAO.Carousel.plugins
const { debounce } = window.BAO.Utils
class WishlistFavouritesCarousel extends window.BAO.CustomElement() {
  static get requiredElements () {
    return ['slides', 'slide']
  }

  connectedCallback () {
    super.connectedCallback()
    if (this.els?.slide?.elements?.length < 2) return
    this.carousel = this.setupCarousel()
  }

  setupListeners () {
    super.setupListeners()

    this.onResize = this.onResize.bind(this)
    this.debouncedResize = debounce(event => {
      this.onResize(event)
    }, 500)
    this.listeners.add(window, 'resize', this.debouncedResize)
  }

  setupCarousel () {
    return new KeenSlider(this.els.slides.element, this.options(), [
      setInitialised(),
      addWheelControls('horizontal'),
    ])
  }

  options () {
    return {
      selector: this.els.slide.selector,
      loop: false,
      mode: 'free-snap',
      defaultAnimation: {
        duration: config.defaultAnimation.duration,
      },
      dragSpeed: config.dragSpeed,
      slides: {
        perView: this.mobilePerView,
        spacing: 20,
      },
      breakpoints: {
        '(min-width: 768px)': {
          slides: {
            perView: this.tabletPerView,
            spacing: spacing(),
          },
        },
        '(min-width: 1024px)': {
          slides: {
            perView: this.desktopPerView,
            spacing: spacing(),
          },
        },
        '(min-width: 1700px)': {
          slides: {
            perView: this.largeDesktopPerView,
            spacing: 20,
          },
        },
      },
    }
  }

  onResize () {
    this.carousel.update(this.options(), this.carousel.track.details.rel)
  }

  get mobilePerView () {
    return parseFloat(this.dataset.mobilePerView) || 1
  }

  get tabletPerView () {
    return parseFloat(this.dataset.tabletPerView) || 2.4
  }

  get desktopPerView () {
    return parseFloat(this.dataset.desktopPerView) || 4.1
  }

  get largeDesktopPerView () {
    return parseFloat(this.dataset.largeDesktopPerView) || 4.6
  }
}

if (!customElements.get('wishlist-favourites-carousel')) {
  customElements.define(
    'wishlist-favourites-carousel',
    WishlistFavouritesCarousel,
  )
}
